import { jsx as _jsx } from "react/jsx-runtime";
import CalendarQuestion from '../../../../ui/atoms/CalendarQuestion';
import Dropdown from '../../../../ui/atoms/Dropdown';
import RadioButton from '../../../../ui/atoms/RadioButton';
import TextArea from '../../../../ui/atoms/TextArea';
import TextField from '../../../../ui/atoms/TextField';
import TableListQuestion from '../../../../ui/atoms/TableListQuestion';
import Chip from '../../../../ui/atoms/Chip';
var QuestionInput = function (_a) {
    var currentQuestion = _a.currentQuestion;
    var answer = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.answers[0];
    var currentQuestionId = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id;
    var fieldType = answer === null || answer === void 0 ? void 0 : answer.fieldType;
    var fieldTypeToInput = {
        RADIOBUTTON: RadioButton,
        CHIPS: Chip,
        DATE: CalendarQuestion,
        DROPDOWN: Dropdown,
        TEXTAREA: TextArea,
        TEXTBOX: TextField,
        TABLE_LIST: TableListQuestion
    };
    var Input = fieldTypeToInput[fieldType];
    return Input ? _jsx(Input, { answer: answer }, currentQuestionId) : null;
};
export default QuestionInput;
//# sourceMappingURL=index.js.map